var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#10338C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 170.695C222.5 170.395 222.7 170.095 223 169.795C222.8 170.095 222.5 170.395 222.2 170.695ZM188 212.595L199 235.495L223.7 229.795L212.7 252.595L232.6 268.395L207.8 273.995L207.9 299.395L188 283.495L168.2 299.395L168.3 273.995L143.5 268.395L163.4 252.595L152.3 229.795L177.1 235.495L188 212.595ZM385.9 241.095L391.1 251.995L402.9 249.295L397.6 260.195L407.1 267.695L395.3 270.295V282.495L385.9 274.895L376.4 282.495L376.5 270.295L364.7 267.695L374.2 260.195L368.9 249.295L380.7 251.995L385.9 241.095ZM337.3 125.095L342.5 135.995L354.3 133.295L349 144.195L358.5 151.695L346.7 154.395V166.495L337.3 158.895L327.8 166.495L327.9 154.395L316 151.695L325.5 144.195L320.2 133.295L332 135.995L337.3 125.095ZM385.9 58.8945L391.1 69.7945L402.9 67.0945L397.6 77.9945L407.1 85.4945L395.3 88.1945V100.295L385.9 92.6945L376.4 100.295L376.5 88.1945L364.7 85.4945L374.2 77.9945L368.9 67.0945L380.7 69.7945L385.9 58.8945ZM428.4 108.595L433.6 119.495L445.4 116.795L440.1 127.695L449.6 135.195L437.8 137.795V149.995L428.4 142.395L418.9 149.995V137.795L407.1 135.195L416.6 127.695L411.3 116.795L423.1 119.495L428.4 108.595ZM398 166.495L402.1 179.195H415.4L404.6 186.995L408.8 199.695L398 191.795L387.2 199.695L391.3 186.995L380.6 179.195H393.9L398 166.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8 -0.00585938V30.5941L209.7 55.6941H254.8V114.994H195.7L254.8 147.794V170.694H228.1L154.6 129.794V170.694H99V122.094L11.6 170.694H-1.19995V140.094L44 114.994H-1.19995V55.6941H57.9001L-1.19995 22.7941V-0.00585938H25.5L99 40.7941V-0.00585938H154.6V48.5941L242.1 -0.00585938H254.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8 -0.00585938H110.8V69.2941H-1.19995V101.294H110.8V170.694H142.8V101.294H254.8V69.2941H142.8V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 114.994L254.8 170.694V154.894L183 114.994H154.6Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 114.994L254.8 170.694V154.894L183 114.994H154.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 114.994L254.8 170.694V154.894L183 114.994H154.6ZM70.7 114.994L-1.19995 154.894V170.694L99 114.994H70.7Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 55.6941L-1.19995 -0.00585938V15.6941L70.7 55.6941H99Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 55.6941L-1.19995 -0.00585938V15.6941L70.7 55.6941H99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 55.6941L-1.19995 -0.00585938V15.6941L70.7 55.6941H99ZM183 55.6941L254.8 15.6941V-0.00585938L154.6 55.6941H183Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.cffb29cda908014fd64e3b2b85869fd3.svg";
export { ForwardRef as ReactComponent };